export default __webpack_public_path__ + "static/media/ico-aws-red-shift-score-low.50d2c010.svg";